import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import BuscarSelecionarUsuario from '@/componentes/formulario/BuscarSelecionarUsuario'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import CampoNome from '@/componentes/formulario/CampoNome'
import CampoNomeSocial from '@/componentes/formulario/CampoNomeSocial'
import SelecionarConvenio from '@/componentes/formulario/SelecionarConvenio'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarDominio from '@/componentes/formulario/SelecionarDominio'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarGenerico from '@/componentes/formulario/SelecionarGenerico'
import SelecionarMultiploDominio from '@/componentes/formulario/SelecionarMultiploDominio'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import router from '@/router'
import MensagemServico from '@/servicos/MensagemServico'
const mensagemServico = new MensagemServico()

export const cadastroMixin = {
  components: {
    BuscarSelecionarUsuario,
    BuscarSelecionarPaciente,
    BlocoFormularioCadastro,
    CampoGenerico,
    CampoNome,
    CampoNomeSocial,
    SelecionarEspecialidade,
    SelecionarGenerico,
    SelecionarDominio,
    SelecionarMultiploDominio,
    SelecionarData,
    SelecionarSituacao,
    SelecionarConvenio,
  },
  mounted() {
    this.recuperarPorId()
  },
  methods: {
    posSalvar(resposta) {
      if (resposta && resposta.erro) {
        mensagemServico.alerta(resposta.erro.content, resposta.erro.title)
        return
      }

      if (this.voltarHistorico) router.go(-1)
      else router.replace({ name: this.consulta })
    },
    recuperarPorId() {
      const id = this.$route.params.id

      if (id) {
        this.servico.recuperar(id).then((res) => {
          this[this.entidade] = res[this.entidade]
          this.processarEntidade(res)
        })
      }
    },
    processarEntidade() {},
    preSalvar() {},
    salvar() {
      this.preSalvar()
      this.v$.$touch()

      if (this.v$.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this[this.entidade]._id) {
          this.servico
            .atualizar(this[this.entidade]._id, this[this.entidade])
            .then((resposta) => this.posSalvar(resposta))
        } else {
          this.servico
            .criar(this[this.entidade])
            .then((resposta) => this.posSalvar(resposta))
        }
      }
    },
  },
}
